import React from "react";
import { FaChrome } from "react-icons/fa";
import { Portfolio } from "../../../../../graphql/generated";
import {
  AboutSectionLeft,
  AboutSectionRight,
  AboutSectionWrapper,
  ServiceCard,
  ServiceList,
} from "./styled";

interface Props {
  portfolioData: Omit<Portfolio, "createdBy">;
}

const AboutSection: React.FC<Props> = ({ portfolioData }) => {
  const allServices = portfolioData?.about?.services || [];

  return (
    <AboutSectionWrapper>
      <AboutSectionLeft>
        <div>
          <h1>{portfolioData?.about?.title || "Hi, My name is Shifat"},</h1>
          <p>
            {portfolioData?.about?.description ||
              "I’m a full stack web developer living in Jatrabari, Dhaka, Bangladesh. I spend my days with my hands in many different areas of web development from back end programming ( PHP, Laravel, NodeJS, Python ) to front end engineering ( HTML, CSS, and jQuery/Javascript, Bootstrap, ReactJS, AngularJS, VueJS, Materialize CSS, Foundation ) , user experience and visual design. I’m extremely passionate about web development."}
          </p>
          <br />
          {portfolioData?.about?.hireMeLinks && (
            <div>
              <h1>Hire me</h1>

              {portfolioData?.about.hireMeLinks?.fiverr && (
                <a
                  href={portfolioData?.about.hireMeLinks?.fiverr}
                  target="blank"
                >
                  <FaChrome /> Fiverr
                </a>
              )}
              {portfolioData?.about.hireMeLinks?.upwork && (
                <a
                  href={portfolioData?.about.hireMeLinks?.upwork}
                  target="blank"
                >
                  <FaChrome /> Upwork
                </a>
              )}
            </div>
          )}
        </div>
      </AboutSectionLeft>

      <AboutSectionRight>
        <h1>My Services...</h1>
        <ServiceList>
          {allServices.map((service) => (
            <ServiceCard key={service.id}>
              <h1>{service.title}</h1>
              <p>{service.description}</p>
            </ServiceCard>
          ))}
        </ServiceList>
      </AboutSectionRight>
    </AboutSectionWrapper>
  );
};

export default AboutSection;
